import { FC } from 'react';

import { SwitchCss } from './SwitchCss';

interface IAntSwitch {
  tab: boolean;
  onChange: (tab: boolean) => void;
}
//Переключатель - Switch
export const Switch: FC<IAntSwitch> = ({ tab, onChange }) => {
  return (
    <SwitchCss
      checked={tab}
      onChange={(e) => onChange(e.target.checked)}
      inputProps={{ 'aria-label': 'ant design' }}
    />
  );
};
